var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerBgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 186,
    viewBox: "0 0 190 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4872_5388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.75 61.6217C182.372 59.6676 184.316 56.9417 185.311 53.826C186.306 50.7103 186.301 47.3612 185.298 44.2482C184.295 41.1352 182.343 38.4145 179.717 36.4675C177.09 34.5205 173.921 33.4449 170.652 33.3914L107.178 30.9919C106.866 30.9703 106.567 30.8589 106.316 30.6711C106.066 30.4833 105.875 30.227 105.767 29.9332L83.8333 -29.3502C82.7312 -32.3664 80.7296 -34.9708 78.0995 -36.8108C75.4693 -38.6509 72.3376 -39.6377 69.1284 -39.6377C65.9192 -39.6377 62.7874 -38.6509 60.1572 -36.8108C57.5271 -34.9708 55.5255 -32.3664 54.4234 -29.3502L32.5599 30.145C32.4519 30.4387 32.2612 30.695 32.0109 30.8828C31.7607 31.0706 31.4615 31.182 31.1494 31.2036L-32.3252 33.6032C-35.5934 33.6566 -38.7629 34.7322 -41.3894 36.6792C-44.0159 38.6262 -45.9676 41.3469 -46.9708 44.4599C-47.9741 47.5729 -47.9786 50.922 -46.9837 54.0377C-45.9888 57.1534 -44.0444 59.8793 -41.4232 61.8334L8.36907 101.003C8.61827 101.199 8.80453 101.464 8.9048 101.765C9.00508 102.066 9.01498 102.39 8.93329 102.697L-8.20484 163.462C-9.09294 166.557 -9.0069 169.85 -7.95843 172.893C-6.90996 175.937 -4.94997 178.583 -2.34509 180.473C0.259789 182.362 3.38309 183.403 6.59993 183.453C9.81676 183.503 12.9709 182.561 15.6334 180.753L68.2468 145.465C68.5059 145.286 68.8134 145.19 69.1284 145.19C69.4433 145.19 69.7508 145.286 70.0099 145.465L122.623 180.753C125.25 182.622 128.393 183.627 131.616 183.627C134.838 183.627 137.981 182.622 140.608 180.753C143.213 178.882 145.175 176.248 146.223 173.215C147.272 170.181 147.355 166.898 146.462 163.815L129.182 102.838C129.091 102.532 129.096 102.205 129.197 101.902C129.298 101.598 129.49 101.334 129.747 101.144L179.75 61.6217Z",
    fill: "url(#paint0_linear_4872_5388)",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4872_5388",
    x: -50.9623,
    y: -42.8734,
    width: 240.252,
    height: 229.736,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.61786,
    result: "effect1_foregroundBlur_4872_5388"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4872_5388",
    x1: 156.101,
    y1: -22.8564,
    x2: 2.5424,
    y2: 171.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#725AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBgStar);
export default __webpack_public_path__ + "static/media/bannerBgStar.dd91511e439d45ca575596ed44b53967.svg";
export { ForwardRef as ReactComponent };